<template>
    <div class="activity-page">
        <header class="page-header">
            <h1 class="page-title">{{ getLabel('activity.centerTitle', 'Centro de Actividades') }}</h1>
            <p class="page-subtitle">{{ getLabel('activity.centerSubtitle', 'Elige una actividad para participar') }}</p>
        </header>

        <main class="activity-list">
            <article
                v-for="act in activities"
                :key="act.key"
                class="activity-card"
                :class="{ highlighted: act.highlighted }"
                @click="goActivity(act)"
            >
                <div class="act-icon" :style="{ background: act.iconBg }">
                    <span class="emoji">{{ act.icon }}</span>
                </div>
                <div class="act-info">
                    <h3 class="act-title">{{ act.title }}</h3>
                    <p class="act-desc">{{ act.desc }}</p>
                </div>
            </article>
        </main>
    </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { Icon } from "vant";

Vue.use(Icon);

export default {
    name: "activity",
    data() {
        return {
            activities: [
                {
                    key: "wheel",
                    title: this.getLabel("activity.luckyWheel", "Ruleta de la Suerte"),
                    desc: this.getLabel("activity.luckyWheelDesc", "Gira la ruleta, gana grandes premios"),
                    icon: "🎡",
                    iconBg: "linear-gradient(135deg, #2a1a5e, #1a3a7a)",
                    path: "/luckDraw",
                    highlighted: true,
                },
                {
                    key: "box",
                    title: this.getLabel("activity.treasureBox", "Cofre del Tesoro"),
                    desc: this.getLabel("activity.treasureBoxDesc", "Invita amigos, abre cofres del tesoro"),
                    icon: "🧰",
                    iconBg: "linear-gradient(135deg, #5e3a1a, #7a5a1a)",
                    path: "/treasureBox",
                    highlighted: false,
                },
                {
                    key: "sign",
                    title: this.getLabel("activity.checkin", "Registro Diario"),
                    desc: this.getLabel("activity.checkinDesc", "Regístrate a diario, gana bonos por racha"),
                    icon: "✅",
                    iconBg: "linear-gradient(135deg, #1a4a5e, #1a6a5e)",
                    path: "/sign",
                    highlighted: false,
                },
                {
                    key: "vip",
                    title: this.getLabel("activity.vipSalary", "Salario VIP"),
                    desc: this.getLabel("activity.vipSalaryDesc", "Mayor nivel VIP, mayor salario"),
                    icon: "👑",
                    iconBg: "linear-gradient(135deg, #5e4a1a, #7a6a1a)",
                    path: "/vip",
                    highlighted: false,
                },
            ],
        };
    },
    created() {
        this.$parent.footer("activity");
    },
    mounted() {
        this.start();
    },
    methods: {
        getLabel(key, fallback) {
            return this.$te(key) ? this.$t(key) : fallback;
        },
        start() {
            // 预留：如后端下发活动列表，可在此覆盖 activities
            Fetch("/index/activity_list", {})
                .then(() => {})
                .catch(() => {});
        },
        goActivity(act) {
            if (!act.path) return;
            this.$router.push(act.path);
        },
    },
};
</script>

<style lang="less" scoped>
.activity-page {
    min-height: 100vh;
    background:
        radial-gradient(circle at 50% 0%, rgba(20, 80, 100, 0.35), transparent 55%),
        #05070f;
    color: #fff;
    padding-bottom: 20px;
}

.page-header {
    padding: 20px 16px 18px;
    text-align: center;
}

.page-title {
    margin: 0 0 6px;
    font-size: 20px;
    font-weight: 700;
    color: #eef3ff;
}

.page-subtitle {
    margin: 0;
    font-size: 13px;
    color: #7a90b0;
}

.activity-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 0 14px;
}

.activity-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px;
    border: 1px solid rgba(60, 120, 130, 0.35);
    border-radius: 14px;
    background: linear-gradient(135deg, rgba(15, 40, 50, 0.85), rgba(10, 25, 35, 0.9));
    cursor: pointer;
    transition: transform 0.15s ease;
}

.activity-card:active {
    transform: scale(0.98);
}

.activity-card.highlighted {
    border-color: #2fd0e6;
    box-shadow: 0 0 14px rgba(45, 208, 230, 0.25);
}

.act-icon {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    border-radius: 14px;
    display: grid;
    place-items: center;
}

.act-icon .emoji {
    font-size: 36px;
    line-height: 1;
}

.act-info {
    flex: 1;
    min-width: 0;
}

.act-title {
    margin: 0 0 6px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
}

.act-desc {
    margin: 0;
    font-size: 12px;
    color: #7a90b0;
    line-height: 1.4;
}
</style>
